import React, { useEffect, useState } from 'react'
import { BreadCrumbSecttion } from '../component/BreadCrumbSecttion'
import Footer from '../component/Footer'
import { Col, Row, Container } from 'react-bootstrap'
import OtherService from '../services/Other'
import PrimaryGradientButton from '../component/PrimaryGradientButton';
import { Link, useNavigate } from 'react-router-dom'
import Loader from '../component/Loader'
import NoData from '../component/NoData'
import { Empty } from "antd";

const ActivityList = () => {

    const [token ,setToken] = useState("");
    const [loadingst ,setLoadingst] = useState(true);
    const [activityList ,setActivityList] = useState([]);
    const [selLang, setSelLang] = useState('');
    const [modalSt, setModalSt] = useState(false);
     
    const [actionStatus, setActionStatus] = useState({isSuccess: true, heading:"", describe:""})
    const [showNotify, setShowNotify] = useState(false)
    const [mloadingst ,setmLoadingst] = useState(true);
    const [campDetails ,setcampDetails] = useState('');
    const [loading, setLoading] = useState(false);

  const getList = async() => {
    setLoadingst(true);
    const userInfo = JSON.parse(localStorage.getItem("userData"));
    OtherService.activityList(userInfo.dcm_contacts_id)
      .then(res => {
        setLoadingst(false);
        if (res.response_code == 200) {
          const list=res.data;
          const entriesArray = Object.entries(list);
          setActivityList(entriesArray);
        } else {
          setActivityList([]);
          const obj = res.response.error;
        }
      })
      .catch(err => {
        setLoadingst(false);
      });
    };

    useEffect(() => {
      getList();
    }, []);

    const shortenText=(text, maxLength)=> {
      if (text.length > maxLength) {
        return text.substring(0, maxLength - 3) + '...';
      }
      return text;
    }

  return (
    <>
      <BreadCrumbSecttion pageTitle="Activity List" currentPageName="Activity List" />
      <section className="py-4">
        <Container>
          {loading ? (
            <Loader />
          ) : activityList.length === 0 ? (
            // <NoData />
            <Empty
              description="No records found"
              classNames={{root: "my-classname"}} styles={{root: {color: "red"}}}/>
          ) : (
            activityList.map(([_, value], index) => (
              <div
                key={index}
                className="border rounded p-3 mb-3 shadow-sm"
                style={{ backgroundColor: '#f9f9f9' }}
              >
                <div><strong>Activity:</strong> {value.activity}</div>
                {/* <div><strong>Date:</strong> {value.created_at}</div> */}
                <div><strong>Date:</strong> {new Date(value.created_at).toLocaleDateString('en-GB', {day: '2-digit', month: 'short', year: 'numeric'})}</div>
              </div>
            ))
          )}
        </Container>
      </section>
      <Footer />
    </>
  )
}

export default ActivityList

